import { render, staticRenderFns } from "./mainpage.vue?vue&type=template&id=619df4da&scoped=true&"
import script from "./mainpage.vue?vue&type=script&lang=js&"
export * from "./mainpage.vue?vue&type=script&lang=js&"
import style0 from "./mainpage.vue?vue&type=style&index=0&id=619df4da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619df4da",
  null
  
)

export default component.exports